import {
  Button,
  CircularProgress,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useReducer } from "react";
import {
  useFindUserForUserQuery,
  useUpdateForUserMutation,
} from "../../api/api-hooks";
import { nullStringCheck } from "../../utils/stringManipulation";
import { Messages, SettingsForm } from "./settingsTypes";

interface Props {
  messagesState: Messages;
  setMessage: (message: string) => void;
}

const initialFormState: SettingsForm = {
  name: "",
  phone: "",
  address: "",
  email: "",
};

const UserInfoForm = ({ messagesState, setMessage }: Props) => {
  const [updateUser] = useUpdateForUserMutation();
  const { data: profile } = useFindUserForUserQuery({});
  const [formState, setFormState] = useReducer(
    (curVals: any, newVals: any) => ({ ...curVals, ...newVals }),
    initialFormState
  );
  useEffect(() => {
    if (profile === undefined) return;
    setFormState({ ...profile });
  }, [profile]);
  if (profile === undefined) return <CircularProgress></CircularProgress>;
  const handler = (event: any) => {
    const { name, value } = event.target;
    setFormState({
      [name]: value,
    });
  };
  const saveContactInfo = () => {
    updateUser({
      updateUserDto: {
        ...formState,
      },
    });
    setMessage("Settings saved.");
  };
  return (
    <Grid
      container
      lg={4}
      md={6}
      item
      direction="column"
      alignItems="flex-start"
      spacing={3}
    >
      <Grid item>
        <Typography variant="h6">Update User Information</Typography>
      </Grid>
      <Grid item style={{ width: "100%" }}>
        <TextField
          name="name"
          label="Name"
          fullWidth
          value={nullStringCheck(formState.name)}
          onChange={handler}
        />
      </Grid>
      <Grid item style={{ width: "100%" }}>
        <TextField
          name="phone"
          label="Phone"
          fullWidth
          value={nullStringCheck(formState.phone)}
          onChange={handler}
        />
      </Grid>
      <Grid item style={{ width: "100%" }}>
        <TextField
          name="address"
          label="Address"
          fullWidth
          value={nullStringCheck(formState.address)}
          onChange={handler}
        />
      </Grid>
      <Grid item>
        <Button
          onClick={saveContactInfo}
          variant="contained"
          color="primary"
          disabled={!!messagesState.contact}
        >
          Submit
        </Button>
      </Grid>
      <Grid item>
        <Typography>{messagesState.contact}</Typography>
      </Grid>
    </Grid>
  );
};

export default UserInfoForm;
